// extracted by mini-css-extract-plugin
export default {"dangerous":"styles_dangerous__9ReHu"};